import React from "react";
import { Box } from "@material-ui/core";
import { ReactComponent as WhatsAppAdIcon } from "../../../static/adTypeIcons/whatsapp-ad.svg";
import { ReactComponent as WhatsAppStatusAdIcon } from "../../../static/adTypeIcons/whatsapp-status-ad.svg";
import { ReactComponent as WebsiteAdIcon } from "../../../static/adTypeIcons/website-ad.svg";
import { ReactComponent as InstantFormAdIcon } from "../../../static/adTypeIcons/instant-form-ad.svg";

const ICON_SIZE = { width: "22px", height: "22px" };

const adTypeIconBox = (children) => (
  <Box
    style={{
      width: "36px",
      height: "36px",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}
  >
    {children}
  </Box>
);

const AD_TYPE_ICONS = {
  ctwa: adTypeIconBox(
    <WhatsAppAdIcon style={{ ...ICON_SIZE, color: "#109d59" }} />
  ),
  whatsapp_status: adTypeIconBox(
    <WhatsAppStatusAdIcon style={{ ...ICON_SIZE, color: "#109d59" }} />
  ),
  website_traffic: adTypeIconBox(
    <WebsiteAdIcon style={{ ...ICON_SIZE, color: "#1877F2" }} />
  ),
  // Website → WhatsApp hybrid: website glyph in the WhatsApp green treatment.
  website_to_whatsapp: adTypeIconBox(
    <WebsiteAdIcon style={{ ...ICON_SIZE, color: "#109d59" }} />
  ),
  lead_form: adTypeIconBox(
    <InstantFormAdIcon style={{ ...ICON_SIZE, color: "#7C3AED" }} />
  ),
};

export default AD_TYPE_ICONS;
